/**
 * @file Helpers for attachments
 */

// Proxy through Cloudflare worker which adds appropriate headers so that
// file at `url` is downloaded instead of opened in the browser.
export function downloadUrl(url: string): string {
  const encodedUrl: string = encodeURIComponent(url)
  return `https://padletcdn.com/cgi/fetch?disposition=attachment&url=${encodedUrl}`
}
